import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from './core/core.module';
import { TableComponent } from './component/shared/table/table.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { PathInterceptor } from './core/interceptors/path.interceptor';
import { GenericComponent } from './page/generic/generic.component';
import { NgxEditorModule } from 'ngx-editor';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModalFormComponent } from './component/shared/modal-form/modal-form.component';
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';

//Components
import { NavBarComponent } from './component/nav-bar/nav-bar.component';
import { HeroSectionComponent } from './component/hero-section/hero-section.component';
import { CarouselComponent } from './component/carousel/carousel.component';
import { FooterComponent } from './component/footer/footer.component';
import { GradientCardComponent } from './component/gradient-card/gradient-card.component';
import { MakingAnImpactCardsComponent } from './component/making-an-impact-cards/making-an-impact-cards.component';
import { NewsAndCurrentAffairsComponent } from './component/news-and-current-affairs/news-and-current-affairs.component';
import { SearchCardComponent } from './component/search-card/search-card.component';
import { HomeComponent } from './page/home/home.component';
import { LayoutComponent } from './layout/layout.component';
import { MissionAndVisionComponent } from './page/mission-and-vision/mission-and-vision.component';
import { SubscribersComponent } from './page/admin/subscribers/subscribers.component';
import { SubscriberTableComponent } from './component/shared/subscriber-table/subscriber-table.component';
import { WelcomeModalComponent } from './component/welcome-modal/welcome-modal.component';

// Admin
import { LoginComponent } from './page/admin/login/login.component';
import { CreateAccountComponent } from './page/admin/create-account/create-account.component';
import { ManageUsersComponent } from './page/admin/manage-users/manage-users.component';
import { ForgotPasswordComponent } from './page/admin/forgot-password/forgot-password.component';
import { CreatePasswordComponent } from './page/admin/create-password/create-password.component';
import { AdminModule } from './views/admin/admin.module';
import { ConfirmCancelComponent } from './component/shared/confirm-cancel/confirm-cancel.component';
import { ResetPasswordComponent } from './page/admin/reset-password/reset-password/reset-password.component';

// Adovacy Dropdown Menu Component
import { CHCCPolicyPerspectiveComponent } from './page/chccpolicy-perspective/chccpolicy-perspective.component';
import { BillPositionsComponent } from './page/bill-positions/bill-positions.component';
import { CHCCPacComponent } from './page/chccpac/chccpac.component';
import { PolicyCoalitionComponent } from './page/policy-coalition/policy-coalition.component';
import { PolicyEngagementAndResourcesComponent } from './page/policy-engagement-and-resources/policy-engagement-and-resources.component';

// Business Resources Dropdown Menu Component
import { SupplierDiversityComponent } from './page/supplier-diversity/supplier-diversity.component';

// Events Dropdown Menu Component
import { CaliforniaBusinessPolicySummitComponent } from './page/california-business-policy-summit/california-business-policy-summit.component';
import { LegislativeAndEconomicOutlookComponent } from './page/legislative-and-economic-outlook/legislative-and-economic-outlook.component';
import { AnnualConventionComponent } from './page/annual-convention/annual-convention.component';

// Membership Dropdown Menu Component
import { ChamberMembersComponent } from './page/chamber-members/chamber-members.component';
import { CorporateMembershipComponent } from './page/corporate-membership/corporate-membership.component';
import { CorporatePartnershipProgramComponent } from './page/corporate-partnership-program/corporate-partnership-program.component';

// Media Dropdown Menu Component
import { NewsAndCurrentAffairComponent } from './page/news-and-current-affair/news-and-current-affair.component';

// About Dropdown Menu Component
import { AboutCHCCComponent } from './page/about-chcc/about-chcc.component';
import { BoardOfDirectorsComponent } from './page/board-of-directors/board-of-directors.component';
import { StaffComponent } from './page/staff/staff.component';
import { CHCCFoundationComponent } from './page/chccfoundation/chccfoundation.component';
import { ContactUsComponent } from './page/contact-us/contact-us.component';
import { FinancialComponent } from './page/financial/financial.component';
import { CheckboxComponent } from './component/shared/checkbox/checkbox.component';
import { ImageModalComponent } from './component/shared/image-modal/image-modal.component';
@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        NavBarComponent,
        HeroSectionComponent,
        CarouselComponent,
        FooterComponent,
        GradientCardComponent,
        MakingAnImpactCardsComponent,
        NewsAndCurrentAffairsComponent,
        SearchCardComponent,
        CHCCPolicyPerspectiveComponent,
        AboutCHCCComponent,
        BoardOfDirectorsComponent,
        CHCCPacComponent,
        LegislativeAndEconomicOutlookComponent,
        LayoutComponent,
        PolicyEngagementAndResourcesComponent,
        CaliforniaBusinessPolicySummitComponent,
        BillPositionsComponent,
        CorporateMembershipComponent,
        StaffComponent,
        SupplierDiversityComponent,
        CHCCFoundationComponent,
        ContactUsComponent,
        FinancialComponent,
        PolicyCoalitionComponent,
        MissionAndVisionComponent,
        NewsAndCurrentAffairComponent,
        AnnualConventionComponent,
        CorporatePartnershipProgramComponent,
        ChamberMembersComponent,
        LoginComponent,
        CreateAccountComponent,
        ForgotPasswordComponent,
        CreatePasswordComponent,
        ManageUsersComponent,
        GenericComponent,
        ConfirmCancelComponent,
        ResetPasswordComponent,
        ModalFormComponent,
        SubscribersComponent,
        WelcomeModalComponent,
        CheckboxComponent,
        ImageModalComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        AppRoutingModule,
        NgbModule,
        FormsModule,
        CoreModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),
        TableComponent,
        SubscriberTableComponent,
        AdminModule,
        NgxEditorModule,
        DragDropModule,
        FontAwesomeModule,
        ClipboardModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: PathInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class AppModule {}
